// extracted by mini-css-extract-plugin
export default {"title":"_0e0f4e60bc","inner_title":"beb63e57da","charge_btn":"_7c3817aa4a"};